import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuard } from './layout/service/auth.guard';
import { NotFoundGuard } from './layout/service/not-found.guard';

const routes: Routes = [
  {
    path: 'lti-pdf-remediation/:id',
    loadChildren: () =>
      import('./pages/pdf-remediation/lti-pdf-remediation.module').then(
        (m) => m.LtiPdfRemediationModule
      ),
  },
  {
    path: 'login-ce',
    loadChildren: () =>
      import('./pages/authentication/login-v1/login-v1.module').then(
        (m) => m.LoginV1Module
      ),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/authentication/login/login.module').then(
        (m) => m.LoginModule
      ),
  },
  // For app.prep.continualengine.com - Use LoginV1Module
  {
    path: 'auth/sso-mard/:etaToken',
    loadChildren: () => {
      const prepDomains = [
        'app.prep.continualengine.com',
        'efsa.prep.continualengine.com',
      ];
      const isPrep = prepDomains.includes(window.location.hostname);
      return isPrep
        ? import('./pages/authentication/login-v1/login-v1.module').then(
            (m) => m.LoginV1Module
          )
        : import('./pages/authentication/login/login.module').then(
            (m) => m.LoginModule
          );
    },
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import(
        './pages/authentication/forgot-password/forgot-password.module'
      ).then((m) => m.ForgotPasswordModule),
  },

  {
    path: 'sign-up',
    loadChildren: () =>
      import('./pages/authentication/sign-up/sign-up.module').then(
        (m) => m.SignUpModule
      ),
  },
  {
    path: 'license_agreement',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './pages/authentication/license-agreement/license-agreement.module'
      ).then((m) => m.LicenseAgreementModule),
  },
  {
    path: 'd2l-config-form',
    loadChildren: () =>
      import('./pages/authentication/config-form/config-form.module').then(
        (m) => m.ConfigFormModule
      ),
  },
  {
    path: 'Y2hhbmdlX3Bhc3N3b3Jk/:userToken/:alphanumeric',
    loadChildren: () =>
      import(
        './pages/authentication/reset-password/reset-password.module'
      ).then((m) => m.ResetPasswordModule),
  },
  {
    path: 'collaborate/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/collaborate/collaborate.module').then(
        (m) => m.CollaborateModule
      ),
  },
  {
    path: 'pdf-remediation/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/pdf-remediation/pdf-remediation.module').then(
        (m) => m.PdfRemediationModule
      ),
  },
  {
    path: 'trns/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/success-page/success-page.module').then(
        (m) => m.SuccessPageModule
      ),
  },
  {
    path: 'disk-space',
    loadChildren: () =>
      import('./pages/disk-space/disk-space.module').then(
        (m) => m.DiskSpaceModule
      ),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./pages/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
        pathMatch: 'full',
      },
      {
        path: 'file-upload',
        loadChildren: () =>
          import('./pages/file-upload/file-upload.module').then(
            (m) => m.FileUploadModule1
          ),
      },
      {
        path: 'usage-dashboard',
        loadChildren: () =>
          import('./pages/usage-dashboard/usage-dashboard.module').then(
            (m) => m.UsageDashboardModule
          ),
      },
      {
        path: 'templates',
        loadChildren: () =>
          import('./pages/templates/templates.module').then(
            (m) => m.TemplatesModule
          ),
      },
      {
        path: 'external-usage',
        loadChildren: () =>
          import('./pages/external-usage/external-usage.module').then(
            (m) => m.ExternalUsageModule
          ),
      },

      // {
      //   path: 'api-usage',
      //   loadChildren: () =>
      //     import('./pages/api-usage/api-usage.module').then(
      //       (m) => m.ApiUsageModule
      //     ),
      // },
      // {
      //   path: 'file-uploads-count',
      //   loadChildren: () =>
      //     import('./pages/file-upload-count/file-upload-count.module').then(
      //       (m) => m.FileUploadCountModule
      //     ),
      // },
      {
        path: 'exports',
        loadChildren: () =>
          import('./pages/file-export/file-export.module').then(
            (m) => m.FileExportModule
          ),
      },
      {
        path: 'ce-admin',
        loadChildren: () =>
          import('./pages/ce-admin/ce-admin.module').then(
            (m) => m.CeAdminModule
          ),
      },
      {
        path: 'RSP-CE-Orders',
        loadChildren: () =>
          import('./pages/rsp-admin/rsp-ce-orders/rsp-ce-orders.module').then(
            (m) => m.RspCeOrdersModule
          ),
      },
      {
        path: 'RSP-Dept-Transaction',
        loadChildren: () =>
          import(
            './pages/rsp-department-transaction/rsp-department-transaction.module'
          ).then((m) => m.RspDepartmentTransactionModule),
      },
      {
        path: 'RSP-Dept-Team',
        loadChildren: () =>
          import('./pages/rsp-department-user/rsp-department-user.module').then(
            (m) => m.RspDepartmentUserModule
          ),
      },
      {
        path: 'Department',
        loadChildren: () =>
          import('./pages/rsp-org-depatments/rsp-org-depatments.module').then(
            (m) => m.RspOrgDepatmentsModule
          ),
      },
      {
        path: 'canvas-lms-files',
        loadChildren: () =>
          import('./pages/canvas-lms/canvas-lms.module').then(
            (m) => m.CanvasLmsModule
          ),
      },
      {
        path: 'blackboard-courses',
        loadChildren: () =>
          import('./pages/blackboard/blackboard.module').then(
            (m) => m.BlackboardModule
          ),
      },
      {
        path: 'civic-plus-files',
        loadChildren: () =>
          import('./pages/civic-plus/civic-plus.module').then(
            (m) => m.CivicPlusModule
          ),
      },
      {
        path: 'civic-plus-v2-files',
        loadChildren: () =>
          import('./pages/civic-plus-v2/civic-plus-v2.module').then(
            (m) => m.CivicPlusV2Module
          ),
      },
      {
        path: 'd2l-lms-files',
        loadChildren: () =>
          import('./pages/dl-lms/dl-lms.module').then((m) => m.DlLmsModule),
      },
      {
        path: 'd2l-api-files',
        loadChildren: () =>
          import('./pages/d2l-api/d2l-api.module').then((m) => m.D2lApiModule),
      },
      {
        path: 'wordpress-files',
        loadChildren: () =>
          import('./pages/wordpress/wordpress.module').then(
            (m) => m.WordpressModule
          ),
      },
      {
        path: 'RSP-CE-Price-Config',
        loadChildren: () =>
          import(
            './pages/rsp-admin/rsp-ce-price-config-client/rsp-ce-price-config-client.module'
          ).then((m) => m.RspCePriceConfigClientModule),
      },
      {
        path: 'RSP-Client-Deleted-Orders',
        loadChildren: () =>
          import(
            './pages/rsp-admin/rsp-client-deleted-orders/rsp-client-deleted-orders.module'
          ).then((m) => m.RspClientDeletedOrdersModule),
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('./pages/rsp-orders/rsp-orders.module').then(
            (m) => m.RspOrdersModule
          ),
      },
      {
        path: 'transcations',
        loadChildren: () =>
          import('./pages/rsp-transaction/rsp-transaction.module').then(
            (m) => m.RspTransactionModule
          ),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./pages/users/users.module').then((m) => m.UsersModule),
      },
      {
        path: 'account-config-old',
        loadChildren: () =>
          import('./pages/user-admin/user-admin.module').then(
            (m) => m.UserAdminModule
          ),
      },
      {
        path: 'account-config',
        loadChildren: () =>
          import(
            './pages/account-config-admin/account-config-admin.module'
          ).then((m) => m.AccountConfigAdminModule),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./pages/user-profile/user-profile.module').then(
            (m) => m.UserProfileModule
          ),
      },
      {
        path: 'resources',
        loadChildren: () =>
          import('./pages/user-resources/user-resources.module').then(
            (m) => m.UserResourcesModule
          ),
      },
      {
        path: 'report',
        loadChildren: () =>
          import('./pages/generate-report/generate-report.module').then(
            (m) => m.GenerateReportModule
          ),
      },
      {
        path: 'new-tree',
        loadChildren: () =>
          import('./pages/k-tree/k-tree.module').then((m) => m.KTreeModule),
      },
      {
        path: 'ce-user-notif',
        loadChildren: () =>
          import('./pages/ce-user-notif/ce-user-notif.module').then(
            (m) => m.CeUserNotifModule
          ),
      },
      {
        path: 'external-contact',
        loadChildren: () =>
          import('./pages/external-contact/external-contact.module').then(
            (m) => m.ExternalContactModule
          ),
      },
      {
        path: 'lms-config',
        loadChildren: () =>
          import(
            './pages/lti-registeration/lti-registeration.module'
          ).then((m) => m.LtiRegisterationModule),
      },
    ],
  },
  {
    path: '**',
    canActivate: [NotFoundGuard],
    children: [],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabled',
      // preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      relativeLinkResolution: 'legacy',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
